








































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {default as Navigation, NavigationObject} from './components/Navigation.vue';
import Slider from './components/Slider.vue';
import Contact from './components/Contact.vue';
import Footer, {FooterObject, PageObject} from './components/Footer.vue';
import Configurator from './components/Configurator.vue';
import Loading from './components/Loading.vue';
import axios from 'axios';
import {CollectionObject as Descriptions} from './components/CollectionDescription.vue';
import News from './components/News.vue';
import Brand from './components/Brand.vue';
import CookieLaw from 'vue-cookie-law';
import Modal from './components/Modal.vue';
import Location, {Marker} from './components/Location.vue';
import imagesLoaded from 'vue-images-loaded';
import ImageText from './components/ImageText.vue';
import Benefits from './components/Benefits.vue';
import Story from './components/Story.vue';
import Products, {Product} from './components/Products.vue';
import Business from "@/components/Business.vue";

interface LoadingStatus {
    content: boolean;
    images: boolean;
    lang: boolean;
}

interface Button {
    text: string;
    href: string;
}

interface ImageTexts {
    title: string;
    subtitle: string;
    description: string;
    image: string;
    width?: string;
    buttons?: Button[];
}

@Component({
    components: {
        Navigation,
        Slider,
        Configurator,
        Contact,
        Footer,
        Loading,
        News,
        Brand,
        CookieLaw,
        Modal,
        Location,
        ImageText,
        Benefits,
        Story,
        Products,
        Business
    },
    directives: {
        imagesLoaded
    },
    data: () => {
        const texts: ImageTexts[] = [
            {
                title: 'Aus Liebe zur Umwelt.\n Aus Liebe für dich.',
                subtitle: 'Glastrinkhalme im 4er-Set.',
                description: `
                          Als Meister der Anpassung steht unser Symbolträger „Pinguin“ für
                          ein Leben ohne Plastik. Mit unserer plastikfreien Alternative leistest
                          du direkt einen positiven Beitrag zur Umwelt und schützt so unsere
                          Pinguine vor der Plastikflut. Erhalten kannst du unsere
                          Glastrinkhalme im praktischen 4er-Set inkl. einer Reinigungsbürste
                          aus Baumwolle. Und das selbstverständlich in einer
                          umweltschonenden Verpackung. Das Set eignet sich auch als
                          großartige Geschenkidee. <br><br>
                          <p><b>Verschenk doch einfach unseren nachhaltigen Hingucker und setze
                          ein Zeichen mit Vorteilen, die garantiert überzeugen</b></p>
                          ✔ 100% plastikfrei<br>
                          ✔ Innovative Idee<br>
                          ✔ Spart bares Geld für Einwegprodukte<br>
                          ✔ Umweltschonende Alternative<br>
                          ✔ Faires Preis-/Leistungsverhältnis<br>
                        `,
                image: './image_text/halm_d.jpg',
                buttons: [
                    {
                        text: 'Jetzt Bestellen',
                        href: 'https://glastrinkhalm.shop/glastrinkhalm-4er-set-20-cm'
                    }
                ]
            },
            {
                title: 'Wir schaffen Alternativen.',
                subtitle: `
                           Glastrinkhalme für höchste Ansprüche -
                           Made in Germany.
                          `,
                description: `
                          Von Anfang an achten wir auf allerbeste Qualität. Daher
                          produzieren wir ausschließlich in Deutschland. Faire
                          Arbeitsbedingungen kombiniert mit traditionellem Handwerk
                          sorgen für ein einzigartiges und zugleich erstklassiges
                          Qualitätsprodukt. Die aus hochwertigem medizinischen
                          Laborglas hergestellten Glastrinkhalme punkten zu 100 % in
                          Sicherheit, Strapazierfähigkeit, Lebensdauer und
                          Umweltbewusstsein. <br> <br>
                          ✔ Plastikfreie wiederverwendbare Alternative<br>
                          ✔ Transparentes stabiles medizinisches Laborglas<br>
                          ✔ Für Heiß- und Kaltgetränke<br>
                          ✔ Frei von Weichmachern wie BPA<br>
                          ✔ 100% geschmacksneutral + lebensmittelecht<br>
                          ✔ Spülmaschinengeeignet<br>
                          ✔ Für Kinder ab 3 Jahren unter Beaufsichtigung<br>
                          ✔ Perfekt für Gastronomie, Handel + privaten Gebrauch

                        `,
                image: './image_text/Halme_b.jpg'
            },
            {
                title: '100% Geschmack.\n Nachhaltig genießen.',
                subtitle: `
                           Genuss pur mit Glastrinkhalmen aus
                           medizinischem Laborglas.
                          `,
                description: `
                          Unsere Glastrinkhalme garantieren zugleich ein gesundes und
                          neutrales Geschmackserlebnis für groß und klein. Im Gegensatz
                          zu Plastiktrinkhalmen sind sie frei von gesundheitsschädlichen
                          Weichmachern und Schwermetallen wie z. B. BPA, Blei und
                          Kadmium. Ohne Bedenken kannst du mit unseren
                          Glastrinkhalmen eine Vielzahl an Getränken einfach pur
                          genießen. Für den vollen Geschmack und ein Genuss ohne
                          Plastik.
                        `,
                image: './image_text/Smoothie_15cm_retusche.jpg'
            },
            {
                title: 'Vielseitig einsetzbar - ob heiß oder kalt.',
                subtitle: `
                           Vom Latte Machiatto bis zum Smoothie.
                          `,
                description: `
                          Mit unseren Glastrinkhalmen kannst du deinen Smoothie stilvoll
                          genießen. Ob Cocktail, Milk-Shake, oder Eiskaffee unsere
                          Trinkhalme sind vielseitig einsetzbar und für viele Kalt- und
                          Heißgetränke die echte Plastik-Alternative. Die Trinkhalme
                          nehmen weder Verfärbungen noch Gerüche an und zeichnen
                          sich insbesondere durch eine einfache Reinigung in der
                          Spülmaschine oder unter Wasser aus. Falls nötig können kleine
                          Verschmutzungen mit der beiliegenden Baumwoll-
                          Reinigungsbürste ganz problemlos entfernt werden. Die
                          dauerhafte Wiederverwendbarkeit ist ein echtes Plus für die
                          Umwelt. Somit hast du mit unseren Glastrinkhalmen einen
                          perfekten Mehrweghelfer und auf Dauer ein unverzichtbares
                          Küchenutensil. Recyceln kannst du die Glastrinkhalme ganz
                          einfach über den Altglascontainer. Somit schonst du dauerhaft
                          die Umwelt.
                        `,
                image: './image_text/Latte_24cm_Knick.jpg'
            },
            {
                title: 'Standard und Slimline.',
                subtitle: `
                           Alleskönner oder pure Eleganz.
                          `,
                description: `
                          <p>Klare Transparenz und das Streben nach Perfektion standen bei
                          der Produktentwicklung unserer Linien im Fokus. Unsere
                          Standard-Linie ist der vielseitige Alleskönner. Die Glastrinkhalme
                          haben einen Durchmesser von 9 mm und sind für unzählige
                          Trinkvariationen einsetzbar. Mit dieser Linie bist du bestens für
                          deine Lieblingsgetränke gerüstet.</p>

                          <p>Für den eleganten Auftritt sorgt unsere Slimline-Edition. Mit
                          einem Durchmesser von 7 mm je Glastrinkhalm ist sie nicht nur
                          eine innovative Umweltlösung, sondern macht deinen Drink zum
                          stilvollen Erlebnis. Die schlichte Eleganz verleiht deinen
                          Getränken auch auf Hochzeiten, runden Geburtstagen oder
                          besonderen Ereignissen das gewisse Etwas und garantiert ein
                          wahres Geschmackserlebnis.</p>

                          Und als kleines Plus kannst du unsere stabilen Glastrinkhalme
                          auch als Rührstäbchen oder Stößel für deine Cocktails und
                          Softdrinks nutzen.
                        `,
                image: './image_text/20cm_beide Durchmesser.jpg'
            }
        ];
        const footerObjects: FooterObject[] = [
            {
                label: 'Robust und Stoßfest',
                icon: 'fas fa-shield-alt'
            },
            {
                label: 'Umwelt-freundlich',
                img: '/benefits/meer_weiss.png'
            },
            {
                label: '100% <br> recyclbar',
                img: '/footer/recycle.png'
            },
            {
                label: 'Lebensmittel-echt',
                img: '/footer/kiss.png'
            },
            {
                label: 'Made in Germany',
                img: '/footer/germany.png'
            },
            {
                label: 'Spühl-maschinenfest',
                img: require('./assets/dishwasher_safe.png')
            }
        ];
        const prods: Product[] = [
            {
                image: '/products/product01.png',
                size: 30,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalme/?o=5&p=1"
            },
            {
                image: '/products/product02.png',
                size: 20,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalm-4er-set-20-cm"
            },
            {
                image: '/products/product03.png',
                size: 15,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalm-4er-set-15-cm"
            },
            {
                image: '/products/product04.png',
                size: 23,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalme-4er-set-23-cm-knickhalme"
            },
            {
                image: '/products/product05.png',
                size: 23,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalm-4er-set-23-cm"
            },
            {
                image: '/products/product06.png',
                size: 15,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalm-4er-set-15-cm"
            },
            {
                image: '/products/product07.png',
                size: 15,
                unit: "cm",
                link: "https://glastrinkhalm.shop/glastrinkhalme-4er-set-15cm-slim-line"
            }
        ];
        return {
            // Loaded by content.json
            nav: [],
            title: '',
            subtitle: '',
            descriptions: [],
            pages: {},
            backend: '',
            shops: [],
            images: [],
            collection: [],
            products: prods,
            // Hardcoded
            footerObjects,
            texts,
            // Default Value
            status: {
                content: false,
                images: false,
                lang: false,
            },
            dropdown: false
        };
    }
})
export default class App extends Vue {
    @Prop({
        type: Promise,
        required: true
    })
    private languageCallback!: Promise<string>;

    private status!: LoadingStatus;
    private language!: object;
    private nav!: NavigationObject[];
    private title!: string;
    private subtitle!: string;
    private descriptions!: Descriptions[];
    private backend!: string;
    private pages!: { [p in string]: PageObject };
    private shops!: Marker[];
    private images!: string[];

    private mounted() {
        this.languageCallback.then((lang) => (this.status.lang = true));
        let mql = window.matchMedia("screen and (min-width: 768px)");
        if (mql.matches) {
            this.toggleDropdown();
        }
        axios
            .get('content.json')
            .then((v) => {
                const data = v.data;
                if (typeof data === 'object') {
                    this.nav = data.navigation;
                    this.title = data.title;
                    this.subtitle = data.subtitle;
                    this.descriptions = data.collections;
                    this.backend = data.backend;
                    this.pages = data.pages;
                    this.shops = data.shops;
                    this.images = data.slider;
                    this.status.content = true;
                } else {
                    try {
                        JSON.parse(data);
                        // tslint:disable-next-line:no-console
                        console.log('Unexpected Error', data);
                    } catch (e) {
                        // tslint:disable-next-line:no-console
                        console.log('Error parsing content', e);
                    }
                }
            })
            .catch((v) => {
                // tslint:disable-next-line:no-console
                console.log('Error loading content', v);
            });
    }

    private loaded() {
        this.status.images = true;
    }

    private get loading() {
        return !this.status.images || !this.status.content || !this.status.lang;
    }

    private toggleDropdown() {
        $(this.$refs.dropdown).collapse('toggle');
        this.$data.dropdown = !this.$data.dropdown;
    }
}
